import { useEffect } from "react"
import styleInject from "style-inject"

const styles = `
  body {
    font-family: Inter, "Open Sans", sans-serif;
    font-size: 14px;
  }

  ul, p {
    padding: 0;
    margin: 0;
  }
`

const GlobalStyles = () => {
  useEffect(() => {
    // Using styleInject to make sure the style tag is inserted at the top,
    // so that it doesn't override any CSS rules introduced by components
    styleInject(styles, { insertAt: "top" })
  }, [])
}

export default GlobalStyles
